import {
  logError as logErrorInternal,
  setUser as setUserInternal,
  clearUser as clearUserInternal,
} from './ErrorUtils';

const dev = __DEV__; //false
if (!dev) {
  console.error = logError;
}

export function logError(message, error) {
  if (dev) return;
  if (!error) error = new Error(message);
  return logErrorInternal(error);
}

export function setUser(userProfileState) {
  if (dev) return;
  return setUserInternal(userProfileState);
}

export function clearUser() {
  if (dev) return;
  return clearUserInternal();
}

module.exports = {
  logError,
  setUser,
  clearUser,
};
